import {BookingData} from '../model/booking';

export const BOOKING_MOCK: BookingData = {
  departure: {
    name: 'Dubai International Airport',
    code: 'DXB',
    country: 'UAE',
    lat: 25.2532,
    lng: 55.3657
  },
  arrival: {
    name: 'London Heathrow',
    code: 'LHR',
    country: 'United Kingdom',
    lat: 51.4700,
    lng: -0.4543
  },
  flight: {
    duration: '10h 30m',
    departureTime: '10:30',
    arrivalTime: '12:30',
    date: '2025-04-04',
    flightType: 'International',
    direction: 'Transit',
    terminal: 'A'
  },
  lounge: {
    name: 'AL MAJLIS LOUNGE',
    description: 'Al Majlis Lounge is a haven of comfort and elegance, designed for travelers who appreciate premium service and refined surroundings. With spacious interiors, gourmet refreshments, private relaxation areas, and personalized assistance, it offers the perfect escape before your flight. Whether you\'re traveling for business or leisure.before your flight. Whether you\'re traveling for business or leisure.',
    price: 343.84,
    images: [
      '../assets/mock1.png',
      '../assets/mock2.png',
      '../assets/mock3.png'
    ],
  },
  services: [
    {
      name: 'Priority Passage',
      price: 6.64,
      multiplier: 1.3
    }
  ]
};
